import type { IconNames } from '@cobliteam/ui/icons';
import Icon from '@cobliteam/ui/icons';

interface BlankslateIconProps {
  iconName: IconNames;
}

const BlankslateIcon = (props: BlankslateIconProps) => {
  return (
    <div className='flex items-center justify-center rounded-full bg-gray-2 p-5'>
      <Icon name={props.iconName} color='gray-light' size='lg' />
    </div>
  );
};

export default BlankslateIcon;
